// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"314":"setting","331":"boss","535":"login"}[chunkId] + "." + {"314":"1c76b6f6","331":"f3e7752a","535":"50486d21"}[chunkId] + ".css";
};